<sdc-bo-dialog
  headerTitle="Event Details"
  [styleClass]="['variant-prominent-title']"
  [attr.data-cy]="'event-details-modal-' + data?.id">
  @if (data) {
    <div class="content-wrapper event-details">
      <section class="event-details-block">
        <h4 class="event-details-section-title">Event</h4>
        <sdc-info-grid [items]="infoItems" [columns]="2" [emptyValue]="''" />
      </section>

      <section class="event-details-block">
        <h4 class="event-details-section-title">Settings</h4>
        <div class="event-settings-grid">
          <div class="event-settings-fields">
            <div class="event-field">
              <label class="event-field-label" for="event-extra-text">
                Extra Text
              </label>
              <input
                id="event-extra-text"
                class="event-field-input"
                type="text"
                [(ngModel)]="data.extraText" />
            </div>
            <div class="event-field">
              <label class="event-field-label" for="event-buyer-type-name">
                Buyer Type Name
              </label>
              <input
                id="event-buyer-type-name"
                class="event-field-input"
                type="text"
                [(ngModel)]="data.defaultBuyerTypeName"
                [class.invalid-input]="hashValidator.buyerTypeName" />
              @if (hashValidator.buyerTypeName) {
                <span class="event-field-error">The entry is not valid</span>
              }
            </div>
            <div class="event-field">
              <label class="event-field-label" for="event-buyer-type">
                Buyer Type
              </label>
              <input
                id="event-buyer-type"
                class="event-field-input"
                type="text"
                [(ngModel)]="data.defaultBuyerType"
                [class.invalid-input]="hashValidator.buyerTypeId" />
              @if (hashValidator.buyerTypeId) {
                <span class="event-field-error">
                  The entry must be number
                </span>
              }
            </div>
          </div>

          <div class="event-image">
            <span class="event-field-label">
              Event image
              <small class="event-image-hint"
                >(transparent png recommended)</small
              >
            </span>
            <div class="event-image-actions">
              <sdc-button variant="secondary" (onClick)="addfile.click()">
                Upload
              </sdc-button>
              @if (data.urlImage || postImage) {
                <sdc-button variant="destructive" (onClick)="removeImage()">
                  Remove
                </sdc-button>
              }
            </div>
            @if (imagePreview || data.urlImage) {
              <img
                class="event-image-preview"
                [src]="imagePreview || data.urlImage"
                alt="Event image preview" />
            } @else {
              <div class="event-image-placeholder">No image</div>
            }
            <input
              type="file"
              class="hidden"
              #addfile
              (change)="onFileChange($event)" />
          </div>
        </div>
      </section>

      <section class="event-details-block">
        <h4 class="event-details-section-title">Associated content</h4>

        <div class="event-associated-group">
          <span class="event-associated-title">
            AdLinks ({{ data.adlinks?.length ?? 0 }})
          </span>
          <div class="event-associated-list">
            @for (adlink of data.adlinks; track adlink.id) {
              <div class="event-associated-item">
                @if (adlink.urlImage) {
                  <img
                    class="event-associated-img"
                    [src]="adlink.urlImage"
                    [alt]="adlink.name" />
                } @else {
                  <div
                    class="event-associated-img-empty"
                    aria-hidden="true"></div>
                }
                <span>{{ adlink.name }} — {{ adlink.title }}</span>
              </div>
            } @empty {
              <p class="event-associated-empty">No ad links associated.</p>
            }
          </div>
        </div>

        <div class="event-associated-group">
          <span class="event-associated-title">
            Upgrades ({{ data.upgrades?.length ?? 0 }})
          </span>
          <div class="event-associated-list">
            @for (upgrade of data.upgrades; track upgrade.id) {
              <div class="event-associated-item">
                <span>{{ upgrade.name }}</span>
              </div>
            } @empty {
              <p class="event-associated-empty">No upgrades associated.</p>
            }
          </div>
        </div>

        <div class="event-associated-group">
          <span class="event-associated-title">
            Upsells ({{ data.upsells?.length ?? 0 }})
          </span>
          <div class="event-associated-list">
            @for (upsell of data.upsells; track upsell.id) {
              <div class="event-associated-item">
                @if (upsell.urlImage) {
                  <img
                    class="event-associated-img"
                    [src]="upsell.urlImage"
                    [alt]="upsell.name" />
                } @else {
                  <div
                    class="event-associated-img-empty"
                    aria-hidden="true"></div>
                }
                <span>{{ upsell.name }}</span>
              </div>
            } @empty {
              <p class="event-associated-empty">No upsells associated.</p>
            }
          </div>
        </div>
      </section>
    </div>
  }
  <ng-container sdc-bo-dialog-footer>
    <sdc-button variant="secondary" (onClick)="onDismiss()">Close</sdc-button>
    <sdc-button variant="primary" (onClick)="onConfirm()">Save</sdc-button>
  </ng-container>
</sdc-bo-dialog>
